import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Check, CircleX, Loader, Trash } from "lucide-react";
import { useState } from "react";
import { TypeParams } from "../Show";
import { useToast } from "@/hooks/use-toast";

export type TypeBtnDeleteProps = {
  params: TypeParams;
  updateFront: () => void;
  referenceLabel?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  hideTrigger?: boolean;
};

export const DeleteBtn = ({
  params,
  updateFront,
  referenceLabel,
  open,
  onOpenChange,
  hideTrigger,
}: TypeBtnDeleteProps) => {
  const [isLoad, setIsLoad] = useState(false);
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = open ?? internalOpen;
  const setIsOpen = (value: boolean | ((prev: boolean) => boolean)) => {
    const next = typeof value === "function" ? value(isOpen) : value;
    setInternalOpen(next);
    onOpenChange?.(next);
  };
  const { toast } = useToast();

  const onDelete = async () => {
    setIsLoad((prev) => !prev);

    const { ok } = await params?.func(params?.funcParams);
    if (!ok) {
      setIsLoad((prev) => !prev);
      setIsOpen((prev) => !prev);
      toast({ description: "Error ao excluir", action: <CircleX /> });
      return;
    }
    updateFront();
    toast({
      description: "Excluído com sucesso!",
      action: <Check color="#1edc2b" />,
    });

    setIsLoad((prev) => !prev);
    setIsOpen((prev) => !prev);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      {!hideTrigger && (
        <DialogTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="size-7 p-0 hover:bg-stone-950/10"
          >
            <Trash className="size-5 !text-red-500" />
          </Button>
        </DialogTrigger>
      )}
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Excluir?</DialogTitle>
          <DialogDescription>
            Deseja mesmo
            {referenceLabel ? (
              <>
                <span className="text-red-500 font-bold"> excluir </span>
                {referenceLabel}?
              </>
            ) : (
              <span className="text-red-500 font-bold"> excluir?!</span>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="bg-red-800 flex gap-1"
            onClick={onDelete}
            disabled={isLoad}
          >
            {isLoad && <Loader className="animate-spin size-4" />}
            Sim
          </Button>
          <Button
            className="bg-green-800"
            disabled={isLoad}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            Não
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
